import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_METRICS_RESPONSE,
  GET_AZURE_METRICS_RESPONSE_SUCCESS,
  GET_AZURE_METRICS_RESPONSE_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureMetricsResponseList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureMetricsResponseStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_METRICS_RESPONSE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_METRICS_RESPONSE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureMetricsResponseList: action.data,
        error: null,
      };
    case GET_AZURE_METRICS_RESPONSE_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
